import { render, staticRenderFns } from "./liaTableComponent2.vue?vue&type=template&id=6113bc5b&scoped=true"
import script from "./liaTableComponent2.vue?vue&type=script&lang=js"
export * from "./liaTableComponent2.vue?vue&type=script&lang=js"
import style0 from "./liaTableComponent2.vue?vue&type=style&index=0&id=6113bc5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6113bc5b",
  null
  
)

export default component.exports